const HomeFooterIconSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 16 18',
  stroke = 'currentColor',
  strokeWidth = 2,
  className = '',
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
  stroke?: string;
  strokeWidth?: number | string;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 8.5L8 2.5L14.5 8.5V15.5H9.5V10.5H6.5V15.5H1.5V8.5Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HomeFooterIconSvg;
